module.exports = __webpack_public_path__ + "static/img/akum_800_80.8806c66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_800_80.svg
// module id = dWbO
// module chunks = 1